

export default [
  {
    path: '/',
    component: () =>
      import('@/views/index.vue'),
  },
]
